import styled from 'styled-components'
import { OptionButton } from '~/pages/anatomyV2/libs/optionButtonStyles'
import {
  anatomyV2ContentWrapperCss,
  anatomyV2RootCss,
} from '~/pages/anatomyV2/libs/pageLayoutStyles'
import { COLORS } from '~/shared/constants/uiConstants'

export const SingleSelectQuestionTemplateStyles = {
  Root: styled.div`
    ${anatomyV2RootCss}
  `,

  ContentWrapper: styled.div`
    ${anatomyV2ContentWrapperCss}
    padding: 16px;
  `,

  Title: styled.h1`
    font-size: 22px;
    font-weight: 700;
    line-height: 1.1;
    color: ${COLORS.BLACK};
    margin-top: 24px;
  `,

  Options: styled.div`
    margin-top: auto;
  `,

  OptionButton,
}
